import { render, staticRenderFns } from "./reg2.vue?vue&type=template&id=41aa6aaf&scoped=true"
import script from "./reg2.vue?vue&type=script&lang=js"
export * from "./reg2.vue?vue&type=script&lang=js"
import style0 from "./reg2.vue?vue&type=style&index=0&id=41aa6aaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aa6aaf",
  null
  
)

export default component.exports